var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"main-content"}},[_c('div',{staticStyle:{"font-size":"30px","font-weight":"bold","text-align":"center"}},[_vm._v("欢迎登录"+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }